import { queryDicDetailAndConfigList } from '../api/biz/master/masterService'

// 长度单位整数部分最大位数（默认值）
const defaultLengthIntegerDigits = {
  'cm': 3,
  'mm': 4,
  'in': 4,
  'inch': 4
}
// 重量单位整数部分最大位数（默认值）
const defaultWeightIntegerDigits = {
  'g': 6,
  'kg': 3,
  'lb': 4,
  'oz': 5
}
// 长度单位小数部分最大位数（默认值）
const defaultLengthDecimalDigits = {
  'cm': 2,
  'mm': 0,
  'in': 2,
  'inch': 2
}
// 重量单位小数部分最大位数（默认值）
const defaultWeightDecimalDigits = {
  'g': 0,
  'kg': 2,
  'lb': 2,
  'oz': 2
}

const state = {
  loaded: false,
  lengthIntegerDigits: { ...defaultLengthIntegerDigits },
  weightIntegerDigits: { ...defaultWeightIntegerDigits },
  lengthDecimalDigits: { ...defaultLengthDecimalDigits },
  weightDecimalDigits: { ...defaultWeightDecimalDigits }
}

const mutations = {
  SET_DIMENSION_LIMIT(state, { lengthIntegerDigits, weightIntegerDigits, lengthDecimalDigits, weightDecimalDigits }) {
    console.log('111111111111', arguments)
    if (lengthIntegerDigits) state.lengthIntegerDigits = lengthIntegerDigits
    if (weightIntegerDigits) state.weightIntegerDigits = weightIntegerDigits
    if (lengthDecimalDigits) state.lengthDecimalDigits = lengthDecimalDigits
    if (weightDecimalDigits) state.weightDecimalDigits = weightDecimalDigits
    state.loaded = true
  }
}

const actions = {
  fetchDimensionLimit({ commit, state }) {
    if (state.loaded) return Promise.resolve()
    return queryDicDetailAndConfigList({ code: 'pdaStrategy' }).then(res => {
  console.log('111111111111', res)
      if (Array.isArray(res) && res.length > 0) {
        const item = res.find(d => d.code === 'dimensionsRegular')
        if (item && item.value) {
          try {
            const rules = JSON.parse(item.value)
             console.log('111111111111', rules)
            if (Array.isArray(rules)) {
              const lengthInt = { ...defaultLengthIntegerDigits }
              const weightInt = { ...defaultWeightIntegerDigits }
              const lengthDec = { ...defaultLengthDecimalDigits }
              const weightDec = { ...defaultWeightDecimalDigits }
              rules.forEach(rule => {
                const unit = (rule.unit || '').toLowerCase()
                if (!unit) return
                if (rule.type === 'DIMENSION') {
                  if (rule.integerDigits != null) lengthInt[unit] = Number(rule.integerDigits)
                  if (rule.decimalDigits != null) lengthDec[unit] = Number(rule.decimalDigits)
                } else if (rule.type === 'WEIGHT') {
                  if (rule.integerDigits != null) weightInt[unit] = Number(rule.integerDigits)
                  if (rule.decimalDigits != null) weightDec[unit] = Number(rule.decimalDigits)
                }
              })
              console.log('111111111111', rules)
              commit('SET_DIMENSION_LIMIT', {
                lengthIntegerDigits: lengthInt,
                weightIntegerDigits: weightInt,
                lengthDecimalDigits: lengthDec,
                weightDecimalDigits: weightDec
              })
            }
          } catch (e) {
            console.warn('dimensionsRegular parse error', e)
          }
        }
      }
    }).catch(e => {
      console.warn('fetchDimensionLimit error', e)
    })
  }
}

const getters = {
  dimensionLimitLoaded: state => state.loaded,
  lengthIntegerDigits: state => state.lengthIntegerDigits,
  weightIntegerDigits: state => state.weightIntegerDigits,
  lengthDecimalDigits: state => state.lengthDecimalDigits,
  weightDecimalDigits: state => state.weightDecimalDigits
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}